import React from "react";
import { Box, Container, Typography } from "@mui/material";
import FormCrearProyecto from "../../components/Proyectos/FormCrearProyecto";
import "./crearProyectoPublico.css";

export default function CrearProyectoPublicoPage() {
  return (
    <Box className="tramites-public-page">
      <Box className="tramites-public-topbar">
        <Container maxWidth="lg" className="tramites-public-topbar-inner">
          <Box className="tramites-public-gov-wrap">
            <img src="/images/logo2.webp" alt="GOV.CO" className="tramites-public-gov-logo" />
          </Box>
          <Typography className="tramites-public-lang">ES</Typography>
        </Container>
      </Box>

      <Box className="tramites-public-logobar">
        <Container maxWidth="lg" className="tramites-public-logobar-inner">
          <Box className="tramites-public-logo-block">
            <img src="/images/logo-emcali.webp" alt="EMCALI" className="tramites-public-logo" />
          </Box>
          <a href="/proyectos/crear" className="tramites-public-back-btn">
            Volver
          </a>
        </Container>
      </Box>

      <Box className="tramites-public-main">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Typography className="tramites-public-title">Solicitud de Proyecto</Typography>
          <Typography className="tramites-public-subtitle">
            Diligencia el formulario para radicar tu solicitud sin iniciar sesion.
          </Typography>

          <Box className="tramites-public-card">
            <FormCrearProyecto publicMode cancelRoute="/proyectos/crear" successRoute="/proyectos/crear" />
          </Box>
        </Container>
      </Box>

      <Box className="tramites-public-footer">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Box className="tramites-public-footer-grid">
            <Box>
              <img
                src="/images/LOGO-EMCALI-vertical-1-tinta-blanca.webp"
                alt="EMCALI"
                className="tramites-public-footer-brand"
              />
            </Box>
            <Box>
              <Typography className="tramites-public-footer-title">Sede Electrónica</Typography>
              <Typography className="tramites-public-footer-text">
                Av 2N entre Calles 10 y 11, CAM Torre EMCALI.
              </Typography>
              <Typography className="tramites-public-footer-text">
                Horario: Lunes a viernes 8:00AM a 5:00PM.
              </Typography>
              <Typography className="tramites-public-footer-text">
                Linea de atencion: 177 - 018000 4 12017
              </Typography>
            </Box>
            <Box>
              <Typography className="tramites-public-footer-title">Información</Typography>
              <Typography className="tramites-public-footer-text">Terminos y condiciones</Typography>
              <Typography className="tramites-public-footer-text">Proteccion de datos personales</Typography>
              <Typography className="tramites-public-footer-text">Mapa del sitio</Typography>
            </Box>
            <Box className="tramites-public-footer-seals">
              <img src="/images/image 7.png" alt="Colombia" className="tramites-public-seal" />
              <img src="/images/image 8.png" alt="Icontec" className="tramites-public-seal" />
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
